import * as React from 'react';

import type { Props as CMLEditorProps } from 'bundles/authoring/content-authoring/components/CMLEditor';
import CMLEditorOrFallbackEditor from 'bundles/authoring/content-authoring/components/CMLEditorOrFallbackEditor';
import type { CmlContent, ImageUploadOptions } from 'bundles/cml';
import { Tools } from 'bundles/cml';

import _t from 'i18n!nls/discussions';

type Props = {
  cml: CmlContent;
  onChange: (cml: CmlContent) => void;
  imageUploadOptions?: ImageUploadOptions;
  placeholder?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  onFirstFocus?: () => void;
  removeFocus?: () => void;
  ariaInvalid?: boolean;
} & Partial<CMLEditorProps>;

/**
 * Wrapper around CMLEditor for all forumsV2 CML editing instances such as replying and creating new threads/posts.
 */
class ForumsCmlEditor extends React.Component<Props> {
  static defaultProps = {
    focusOnLoad: true,
  };

  render() {
    const {
      cml,
      onChange,
      imageUploadOptions,
      placeholder,
      onFocus,
      onBlur,
      ariaLabel,
      ariaDescribedBy,
      focusOnLoad,
      ariaRequired,
      ariaInvalid,
    } = this.props;

    return (
      <div className="rc-ForumsCmlEditor">
        <CMLEditorOrFallbackEditor
          {...this.props}
          initialCML={cml}
          onContentChange={onChange}
          uploadOptions={{ image: imageUploadOptions, asset: imageUploadOptions }}
          isLearnerUpload={true}
          onFocus={onFocus}
          onBlur={onBlur}
          focusOnLoad={focusOnLoad}
          placeholder={placeholder || _t('Reply')}
          customTools={[
            Tools.BOLD,
            Tools.ITALIC,
            Tools.UNDERLINE,
            Tools.MATH,
            Tools.LINK,
            Tools.UNLINK,
            Tools.IMAGE,
            Tools.UNORDERED_LIST,
            Tools.ORDERED_LIST,
            Tools.CODE,
            Tools.SUBSCRIPT,
            Tools.SUPERSCRIPT,
          ]}
          ariaLabel={ariaLabel || _t('Post Reply')}
          ariaDescribedBy={ariaDescribedBy}
          ariaRequired={ariaRequired}
          ariaInvalid={ariaInvalid}
        />
      </div>
    );
  }
}

export default ForumsCmlEditor;
